"use strict";

class ProductTabs {
	constructor(el) {
		this.el = el;
		this.tabs = Array.from(this.el.querySelectorAll('input[type="radio"]'));
		this.panels = Array.from(
			this.el.querySelectorAll('article[role="tabpanel"]')
		);
		this.currentTab = null;
		this.currentPanel = null;

		this.init();
	}

	init() {
		this.tabs.forEach((tab) => {
			tab.addEventListener("change", (e) => {
				const t = e.target;
				e.preventDefault();
				e.stopPropagation();

				if (t.checked) {
					this.setCurrentTab(t.getAttribute("aria-controls"));
				}
			});
		});

		this.setCurrentTab(this.panels[0].id);

		this.el.classList.add("initialized");
	}

	setCurrentTab(id) {
		this.tabs.forEach((t) => {
			const controls = t.getAttribute("aria-controls");
			if (controls == id) {
				this.currentPanel = this.panels.find((p) => p.id == id);
				this.currentTab = t;
				this.currentTab.setAttribute("aria-selected", true);
				this.currentTab.click();
				this.currentPanel.classList.remove("hidden");
			} else {
				const panel = this.panels.find((p) => p.id == controls);

				t.setAttribute("aria-selected", "false");
				panel.classList.add("hidden");
			}
		});

		this.panels.forEach((p) => {
			if (p.id == id) {
				this.currentTab = p;
				this.currentTab.classList.remove("hidden");
			} else {
				p.classList.add("hidden");
			}
		});

		// if (this.el.classList.contains("initialized")) {
		// 	window.scroll({
		// 		top: this.el.getBoundingClientRect().top + window.scrollY,
		// 		behavior: "smooth",
		// 	});
		// }
	}
}

window.addEventListener("DOMContentLoaded", () => {
	let tabs = document.querySelectorAll(".product-tabs");

	tabs.forEach((t) => {
		new ProductTabs(t);
	});
});

// if (tabs.length > 0) {

// } else {
// 	const productTabInterval = setInterval(() => {
// 		tabs = document.querySelectorAll(".product-tabs");

// 		if (tabs.length > 0) {
// 			clearInterval(productTabInterval);
// 			tabs.forEach((t) => {
// 				new ProductTabs(t);
// 			});
// 		}
// 	}, 64);
// }
